import { gql } from '@apollo/client';

export const SEND_SUBSCRIPTION = gql`
  mutation SendSubscription($input: SendSubscriptionInput!) {
    sendSubscription(input: $input) {
      status
    }
  }
`;
